import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import getAllResourcesWithProjectBusinessId from '../services/getAllResourcesWithProjectBusinessId';

export const loadAllResourcesWithProjectBusinessId = createAsyncThunk(
  'resources/loadAllResourcesWithProjectBusinessId',
  async (selectedProjectId, { getState }) => {
    // const state = getState();

    // const project = selectSelectedProject(state);
    // console.log(" project:", project)

    const response = await getAllResourcesWithProjectBusinessId(
      selectedProjectId
    );
    return response ? response.employerProjects : [];
  }
);
